import type { BlogPost } from "./types";
import { maximizingRentalCashFlow2026 } from "./posts/maximizingRentalCashFlow2026";
import { tenantScreeningGuide } from "./posts/tenantScreeningGuide";
import { howToFindAPropertyManager } from "./posts/howToFindAPropertyManager";
import { rentVsSellGuide } from "./posts/rentVsSellGuide";
import { tenantScreeningProcessExplained } from "./posts/tenantScreeningProcessExplained";
import { automatedRentCollection } from "./posts/automatedRentCollection";
import { feingoldVsSelfManaging } from "./posts/feingoldVsSelfManaging";

export type { BlogPost, BlogSection } from "./types";

export const blogPosts: BlogPost[] = [
  maximizingRentalCashFlow2026,
  tenantScreeningGuide,
  howToFindAPropertyManager,
  rentVsSellGuide,
  tenantScreeningProcessExplained,
  automatedRentCollection,
  feingoldVsSelfManaging,
];

export const getBlogPostBySlug = (slug: string): BlogPost | undefined =>
  blogPosts.find((p) => p.slug === slug);
